var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "section" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("Header", _vm._b({}, "Header", _vm.$route.meta, false)),
        _c("div", { staticClass: "columns mt-6" }, [
          _c("div", { staticClass: "column" }, [
            _c(
              "div",
              { staticClass: "box" },
              [
                _c(
                  "b-field",
                  { attrs: { label: "Plant" } },
                  [
                    _c("b-autocomplete", {
                      attrs: {
                        placeholder: "Select a plant...",
                        data: _vm.filteredPlants,
                        "open-on-focus": "",
                        field: "id",
                        icon: "magnifying-glass",
                      },
                      on: {
                        typing: _vm.getFilteredPlants,
                        select: _vm.selectPlant,
                      },
                      model: {
                        value: _vm.selectedPlantId,
                        callback: function ($$v) {
                          _vm.selectedPlantId = $$v
                        },
                        expression: "selectedPlantId",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "column" }, [
            _c(
              "div",
              { staticClass: "box" },
              [
                _c(
                  "b-field",
                  { attrs: { label: "Material" } },
                  [
                    _c(
                      "b-select",
                      {
                        attrs: {
                          placeholder: "Select material...",
                          expanded: "",
                        },
                        model: {
                          value: _vm.selectedMaterial,
                          callback: function ($$v) {
                            _vm.selectedMaterial = $$v
                          },
                          expression: "selectedMaterial",
                        },
                      },
                      _vm._l(_vm.materials, function (option) {
                        return _c(
                          "option",
                          { key: option, domProps: { value: option } },
                          [_vm._v(" " + _vm._s(option) + " ")]
                        )
                      }),
                      0
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "column" }, [
            _c(
              "div",
              { staticClass: "box" },
              [
                _c(
                  "b-field",
                  { attrs: { label: "Operation" } },
                  [
                    _c(
                      "b-select",
                      {
                        attrs: {
                          placeholder: "Select a operation...",
                          expanded: "",
                        },
                        model: {
                          value: _vm.selectedOperation,
                          callback: function ($$v) {
                            _vm.selectedOperation = $$v
                          },
                          expression: "selectedOperation",
                        },
                      },
                      _vm._l(_vm.operations, function (option) {
                        return _c(
                          "option",
                          {
                            key: option.value,
                            domProps: { value: option.value },
                          },
                          [_vm._v(" " + _vm._s(option.text) + " ")]
                        )
                      }),
                      0
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "column" }, [
            _c(
              "div",
              { staticClass: "box" },
              [
                _c(
                  "b-field",
                  { attrs: { label: "Dates" } },
                  [
                    _c(
                      "b-datepicker",
                      {
                        attrs: {
                          placeholder: "Click to select...",
                          "first-day-of-week": 1,
                          icon: "calendar",
                          multiple: "",
                        },
                        on: {
                          "change-month": _vm.changeMonth,
                          "change-year": _vm.changeYear,
                        },
                        model: {
                          value: _vm.selectedDates,
                          callback: function ($$v) {
                            _vm.selectedDates = $$v
                          },
                          expression: "selectedDates",
                        },
                      },
                      [
                        _c("b-button", {
                          attrs: {
                            label: "Clear",
                            "icon-left": "close",
                            outlined: "",
                          },
                          on: {
                            click: function ($event) {
                              _vm.selectedDates = []
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "column" }, [
            _c(
              "div",
              { staticClass: "box" },
              [
                _c(
                  "b-field",
                  { attrs: { label: "Quantity" } },
                  [
                    _c("b-input", {
                      attrs: { placeholder: "Enter quantity..." },
                      model: {
                        value: _vm.inputQty,
                        callback: function ($$v) {
                          _vm.inputQty = $$v
                        },
                        expression: "inputQty",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "mt-6" },
          [
            !_vm.values.length
              ? _c(
                  "div",
                  [
                    _c("p", [
                      _vm._v(
                        "No simulation found, select some criterias to see more data..."
                      ),
                    ]),
                    _c("b-skeleton", {
                      attrs: { width: "20%", animated: true },
                    }),
                    _c("b-skeleton", {
                      attrs: { width: "40%", animated: true },
                    }),
                    _c("b-skeleton", {
                      attrs: { width: "60%", animated: true },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _c("b-loading", {
              attrs: { "is-full-page": false, "can-cancel": true },
              model: {
                value: _vm.isLoading,
                callback: function ($$v) {
                  _vm.isLoading = $$v
                },
                expression: "isLoading",
              },
            }),
            _vm.values.length
              ? _c(
                  "la-cartesian",
                  {
                    attrs: {
                      bound: [0, (n) => n + 50],
                      narrow: "",
                      autoresize: "",
                      colors: _vm.colors,
                      "text-color": _vm.textColor,
                      data: _vm.values,
                    },
                  },
                  [
                    _c("la-bar", { attrs: { animated: "", prop: "qty" } }),
                    _c("la-line", {
                      attrs: {
                        dot: "",
                        curve: "",
                        animated: "",
                        "show-value": true,
                        label: "quantity",
                        prop: "qty",
                      },
                    }),
                    _c("la-x-axis", {
                      attrs: {
                        "font-size": 10,
                        format: (date) => date.slice(0, 5),
                        prop: "requestDate",
                      },
                    }),
                    _c("la-y-axis", { attrs: { "font-size": 10 } }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _c("div", { staticClass: "buttons level mt-6" }, [
          _c(
            "div",
            { staticClass: "level-left" },
            [
              _c(
                "b-button",
                {
                  attrs: { disabled: _vm.diableRefresh },
                  on: { click: _vm.refresh },
                },
                [_vm._v(" Refresh ")]
              ),
              _c(
                "b-button",
                {
                  attrs: {
                    "icon-left": "floppy-disk",
                    type: "is-primary",
                    disabled: _vm.disableSave,
                    loading: _vm.buttonLoading,
                  },
                  on: { click: _vm.save },
                },
                [_vm._v(" Save ")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "level-right" },
            [
              _c(
                "b-button",
                {
                  attrs: {
                    "icon-left": "backward",
                    disabled: _vm.disableReset,
                  },
                  on: { click: _vm.reset },
                },
                [_vm._v(" Reset ")]
              ),
              _c(
                "b-button",
                {
                  attrs: {
                    "icon-left": "play",
                    disabled: _vm.disableButtons,
                    loading: _vm.buttonLoading,
                    type: "is-info",
                  },
                  on: { click: _vm.simulate },
                },
                [_vm._v(" Simulate ")]
              ),
            ],
            1
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }